import React from 'react'

export default function FutureMineralPricesMineralDetailsLoading() {
  return (
    <div className="border-muted-300 flex border-2">
      <div className="bg-muted-300 !h-20 !w-20 p-2" />
      <div className="flex min-w-64 flex-col justify-between gap-1 p-2">
        <div className="flex items-center justify-between gap-4">
          <div className="bg-muted-300 h-6 w-32" />
          <div className="bg-muted-300 h-6 w-28" />
        </div>
        <div className="flex items-center justify-between gap-4">
          <div className="bg-muted-300 h-5 w-20" />
          <div className="bg-muted-300 h-5 w-16" />
        </div>
      </div>
    </div>
  )
}
